export const UsersIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="8" r="3" stroke={color} strokeWidth="2"/>
    <circle cx="17" cy="9" r="2.5" stroke={color} strokeWidth="2"/>
    <path d="M3 19a6 6 0 0 1 12 0" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M14 19c0-2.2 1.8-4 4-4 1.2 0 2.2.4 3 1.2" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
